<ion-card>
  <ion-card-content>
    <ion-text color="primary">
      <h2 class="ion-text-center">Elige un metodo para seleccionar tu billete</h2>
    </ion-text>

    <ion-grid>
      <ion-row class="big-buttons">
        <ion-col size="6">
          <ion-card button (click)="isAuto = !isAuto" [color]="isAuto ? 'primary' : undefined">
            <ion-card-content>
              <ion-icon slot="primary" name="dice-outline"></ion-icon>
              <h2 class="ion-text-center">Automático</h2>
            </ion-card-content>
          </ion-card>
        </ion-col>
        <ion-col size="6">
          <ion-card button (click)="nowGoTo()" [color]="!isAuto ? 'primary' : undefined">
            <ion-card-content>
              <ion-icon slot="primary" name="apps-outline"></ion-icon>
              <h2 class="ion-text-center">Manual</h2>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row class="bet ion-margin-vertical ion-padding-vertical" *ngIf="isAuto">
        <ion-col size="8">
          <h4>Número de billetes</h4>
        </ion-col>
        <ion-col size="4">
          <app-quantity
            [max]="type === 'melate' ? 4 : 100"
            [quantity]="quantity"
            (quantityChange)="changeQuantity($event)"
          ></app-quantity>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="isAuto">
        <ion-col size="12">
          <ng-content></ng-content>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <ion-text color="medium" class="ion-padding-vertical">
            <h3 class="ion-text-center">Mandale a tu amigo un cachito, comparte la suerte</h3>
          </ion-text>
        </ion-col>
        <ion-col size="7">
          <ion-item lines="none" class="input ion-margin-top">
            <ion-input (ionInput)="changeEmail($event)" type="text" placeholder="Correo"></ion-input>
          </ion-item>
        </ion-col>

        <ion-col size="5">
          <ion-button [disabled]="!isValidMail" class="share ion-margin-top" expand="block">
            <ion-icon slot="start" name="mail-outline"></ion-icon>
            Enviar
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
